var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHowTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9714443,20.2499517 C17.4857221,20.2499517 18,19.8702806 18,19.2374696 L18,18.6046586 C18,18.3515187 17.8714207,18.0983789 17.6143014,17.8452777 C17.4857221,17.2124667 17.4857221,15.4406036 17.6143014,14.9343239 C17.8714207,14.8077926 18,14.5546528 18,14.1749817 L18,1.01248214 C18,0.379671145 17.6143014,0 16.9714443,0 L3.85714286,0 C1.67141288,0 0,1.64529313 0,3.79686595 L0,16.4530858 C0,18.6046586 1.67141288,20.2499517 3.85714286,20.2499517 L16.9714443,20.2499517 Z",
    fill: "#8B9799",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2999922,17.7187078 L3.85714286,17.7187078 C3.08570644,17.7187078 2.57142857,17.2124667 2.57142857,16.4530858 C2.57142857,15.6937049 3.21428571,15.1874638 3.85714286,15.1874638 L15.2999922,15.1874638 L15.2999922,17.7187078 Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2142857,6.78571429 C10.4509626,6.78571429 10.6428571,6.97760882 10.6428571,7.21428571 L10.6428571,7.21428571 L10.6428571,10.7857143 L11.0714286,10.7857143 C11.3081055,10.7857143 11.5,10.9776088 11.5,11.2142857 L11.5,11.2142857 L11.5,12.0714286 C11.5,12.3081055 11.3081055,12.5 11.0714286,12.5 L11.0714286,12.5 L7.92857143,12.5 C7.69189453,12.5 7.5,12.3081055 7.5,12.0714286 L7.5,12.0714286 L7.5,11.2142857 C7.5,10.9776088 7.69189453,10.7857143 7.92857143,10.7857143 L7.92857143,10.7857143 L8.35714286,10.7857143 L8.35714286,8.5 L7.92857143,8.5 C7.69189453,8.5 7.5,8.30810547 7.5,8.07142857 L7.5,8.07142857 L7.5,7.21428571 C7.5,6.97760882 7.69189453,6.78571429 7.92857143,6.78571429 L7.92857143,6.78571429 Z M9.5,3 C10.3284389,3 11,3.6715611 11,4.5 C11,5.3284389 10.3284389,6 9.5,6 C8.6715611,6 8,5.3284389 8,4.5 C8,3.6715611 8.6715611,3 9.5,3 Z",
    fill: "#FFF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowTo);
export default __webpack_public_path__ + "static/media/how-to.913b8b42.svg";
export { ForwardRef as ReactComponent };